import React, { useEffect, useState } from 'react';
import Glide from '@glidejs/glide';
import '@glidejs/glide/dist/css/glide.core.min.css';
import '@glidejs/glide/dist/css/glide.theme.min.css';
import './FAQPage.scss';
import { NavLink, useNavigate } from 'react-router-dom';

const glide = new Glide('.glide', {
    type: 'carousel',
    perView: 1,
    focusAt: 'center',
    autoplay: false,
    breakpoints: {
        1024: {
            perView: 1
        },
        768: {
            perView: 1
        }
    },
    dragThreshold: false,
    animationDuration: 200
});

export const FAQPage = ({toggleFAQ}) => {

    const [showPrevButton, setShowPrevButton] = useState(false);
    const [showNextButton, setShowNextButton] = useState(true);
    const [showDoneButton, setShowDoneButton] = useState(false);

    useEffect(() => {
        

        glide.on(['mount.after', 'run'], () => {
            const index = glide.index;
            switch (index) {
                case 0:
                    setShowPrevButton(false);
                    setShowNextButton(true);
                    setShowDoneButton(false);
                    break;
            
                case 1:
                    setShowPrevButton(true);
                    setShowNextButton(true);
                    setShowDoneButton(false);
                    break;
            
                case 2:
                    setShowPrevButton(true);
                    setShowNextButton(false);
                    setShowDoneButton(true);
                    break;
            
                default:
                    break;
            }
        });

        glide.mount();

        return () => {
            //glide.destroy();
        };
    }, []);

    const handlePrev = () => {
        glide.go('<');
    };

    const handleNext = () => {
        glide.go('>');
    };

    const handleDone = () => {
        glide.go('=0');
        toggleFAQ()
    };

    return (
            <div className="glide">
                <div className="glide__track" data-glide-el="track">
                    <ul className="glide__slides">
                        <li className="glide__slide">
                            <img className='img-slide' src={require('../../assets/capture1.png')} alt="Slide 1" />
                            <div className="slide-content">
                                <h2>Hacé un seguimiento de tu carrera</h2>
                                <p>Registrá las materias que aprobaste y observa las correlatividades de forma sencilla </p>
                            </div>
                        </li>
                        <li className="glide__slide">
                            <img className='img-slide' src={require('../../assets/capture2.png')}alt="Slide 2" />
                            <div className="slide-content">
                                <h2>Planificá tus horarios para ver qué te conviene</h2>
                                <p>Elegí varias comisiones y compara sus horarios para ver cual preferis</p>
                            </div>
                        </li>
                        <li className="glide__slide">
                            <img className='mail' src={require('../../assets/capture3.png')} alt="Slide 3" />
                            <div className="slide-content">
                                <h2>Si tenes sugerencias mandamelas por instagram: <a target='_blank' href="https://www.instagram.com/mi.utn.fra">@mi.utn.fra</a></h2>
                            </div>
                        </li>
                    </ul>
                </div>
                <div className="glide__arrows" data-glide-el="controls">
                {showPrevButton && <button className="btn-arrow" onClick={handlePrev} data-glide-dir="<">Anterior</button>}
                {showNextButton && <button className="btn-arrow" onClick={handleNext} data-glide-dir=">">Siguiente</button>}
                </div>
                <svg onClick={()=>{ handleDone() }} className="close-svg" width="30" height="30" viewBox="0 0 500 500" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M121.333 75.6667L250 204.333L378 76.3334C380.827 73.324 384.233 70.9166 388.014 69.2555C391.794 67.5944 395.871 66.7139 400 66.6667C408.84 66.6667 417.319 70.1786 423.57 76.4299C429.821 82.6811 433.333 91.1595 433.333 100C433.411 104.087 432.653 108.146 431.105 111.929C429.557 115.713 427.253 119.14 424.333 122L294.667 250L424.333 379.667C429.827 385.041 433.049 392.32 433.333 400C433.333 408.841 429.821 417.319 423.57 423.57C417.319 429.822 408.84 433.333 400 433.333C395.752 433.51 391.513 432.801 387.554 431.251C383.594 429.702 380 427.346 377 424.333L250 295.667L121.667 424C118.85 426.909 115.485 429.232 111.767 430.834C108.048 432.436 104.049 433.285 99.9999 433.333C91.1593 433.333 82.6809 429.822 76.4297 423.57C70.1785 417.319 66.6666 408.841 66.6666 400C66.5888 395.913 67.3471 391.854 68.8947 388.071C70.4424 384.288 72.7468 380.861 75.6666 378L205.333 250L75.6666 120.333C70.1727 114.959 66.9512 107.68 66.6666 100C66.6666 91.1595 70.1785 82.6811 76.4297 76.4299C82.6809 70.1786 91.1593 66.6667 99.9999 66.6667C108 66.7667 115.667 70.0001 121.333 75.6667Z" fill="#ED4C5C"/>
                </svg>
            </div>
    );
};
